export enum ConfigCellType {
    Cube = 'Cube',
    Rollups = 'Rollups',
    Custom = 'Custom',
}
